import { render } from "./AddBoxItems.vue?vue&type=template&id=583c565e"
import script from "./AddBoxItems.vue?vue&type=script&lang=js"
export * from "./AddBoxItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__